import { ColumnDef } from "@tanstack/react-table";
import type { Instructor } from "../types/instructor";

export const instructorTableDef = ({
  activateInstructor,
  editInstructor,
}: {
  activateInstructor: ({ id }: { id: number }) => Promise<void>;
  editInstructor: (id: number) => void;
}): ColumnDef<Instructor, any>[] => [
  {
    accessorKey: "id",
    header: "id",
  },
  {
    accessorKey: "name",
    header: "이름",
  },
  {
    accessorKey: "email",
    header: "이메일",
  },
  {
    accessorKey: "corp_name",
    header: "기관 이름",
  },
  {
    accessorKey: "corp_address",
    header: "기관 주소",
  },
  {
    accessorKey: "corp_id",
    header: "기관 아이디",
  },
  {
    accessorKey: "is_active",
    header: "비밀번호 전송",
    cell: ({ cell, row }) =>
      !cell.getValue()
        ? row.original.id && (
            <div className="buttonCenterWrapper">
              <button
                onClick={async () => {
                  try {
                    activateInstructor({
                      id: row.original.id,
                    });
                    alert("전송되었습니다.");
                  } catch (e) {
                    alert("에러가 발생했습니다.");
                  }
                }}
              >
                전송
              </button>
            </div>
          )
        : "완료",
  },
  {
    header: "수정",
    cell: ({ row }) => (
      <button onClick={() => editInstructor(row.original.id)}>수정</button>
    ),
  },
];
